import { gql } from '@apollo/client';

export const GET_DRIVER_GROUPS = gql`
  query GetDriverGroups {
    driverGroups {
      id
      name
      description
      members {
        userId
        user {
          id
          firstName
          lastName
          role
          status
          profile {
            pictureThumbnail
          }
        }
      }
    }
  }
`;

export const GET_DRIVER_GROUP = gql`
  query GetDriverGroup($id: Int!) {
    driverGroup(id: $id) {
      id
      name
      description
      members {
        userId
        user {
          id
          firstName
          lastName
          role
          status
          profile {
            pictureThumbnail
          }
        }
      }
    }
  }
`;
